<template>
  <div class="page">
    <PaymentScreen/>
  </div>
</template>

<script>
import PaymentScreen from "@/components/point-of-sale/sales/payment/PaymenScreen";

export default {
  name: "PaymentView",
  async beforeMount() {
    this.$store.commit(`generateSaleUUID`)

    // Check if there's a saleNumber in the query params (direct navigation to payment)
    const saleNumber = this.$route.query.saleNumber;
    if (saleNumber) {
      try {
        // Load the table data into the store so PaymentScreen can access it
        await this.$store.dispatch('getTableBySaleNumber', saleNumber);
      } catch (error) {
        console.error('[PaymentView] Failed to load table data:', error);
        // Continue anyway - the payment screen will handle the error
      }
    }
  },
  components: {PaymentScreen},
}
</script>

<style lang="scss" scoped>
.page {
  background: var(--bg-gradient);
  overflow-y: auto;
}
</style>
